module.exports = __webpack_public_path__ + "media/assets/icons/conference-room-4751c10fe3d346bcef3fd2ec56b43308.png";